import { ApiResponseType, BaseResponseType, RequestOptions } from '@/types/sharedTypes';
import { authApiService } from '@/api/authApiService';

export const blockOpcoInternalUserApi = async (
  userId: string,
  options?: RequestOptions
): Promise<ApiResponseType<BaseResponseType>> => {
  const uri = `/opco/internal/users/${userId}/status:block/`;

  return authApiService.POST(uri, {}, null, options);
};
